import { render } from "./contractPriceUpdateComponent.vue?vue&type=template&id=8c0541ba&scoped=true"
import script from "./contractPriceUpdateComponent.vue?vue&type=script&lang=js"
export * from "./contractPriceUpdateComponent.vue?vue&type=script&lang=js"

import "./contractPriceUpdateComponent.vue?vue&type=style&index=0&id=8c0541ba&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0541ba"]])

export default __exports__